<template>
  <div class="ma-0 pa-0 mt-n10">
    <v-container>
      <div>
        <CRUDList class="mt-10" :canAdd="false"
          :canEdit="false" :canSave="true" :showSelect="false"
          :enableFixedHeaders="true" :hideDefaultFooter="true" :displayTopPagination="false"
          :headers="headers" :baseCrudKey="baseCrudKey"
          tableWrapperDynamicClassname='taxroll-table-wrapper'
          tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='300'
          :loadingData="gridLoading.flag" :loadingText="gridLoading.text"
          :defaultSortBy="defaultSortBy" @loadCRUDList="getAccessorFileMergeAndFinalizeMethod">
        </CRUDList>
        <v-row>
          <p class="input-text-size mt-4">{{ statusMessage }}</p>
          <v-col cols="2"></v-col>
          <v-col>
            <v-btn color="primary" small dense class="mr-2 mt-5"
              @click="mergeTaxOwner" :disabled="checkIfMergeTaxOwnerIsDisabled('taxOrOwnerCount')"
              >Merge Tax/Owner</v-btn>
            <v-btn color="primary" small dense class="mr-2 mt-5"
              @click="mergeSummary" :disabled="checkIfMergeTaxOwnerIsDisabled('summaryCount')"
              >Merge Summary</v-btn>
            <v-btn color="primary" small dense class="mt-5"
              @click="mergeComments" :disabled="checkIfMergeTaxOwnerIsDisabled('commentsCount')"
              >Merge Comments</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-btn color="primary" small dense class="mt-5"
              @click="changeDefaultTaxYear">
              Change Default Tax Year
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { mergeNFinalizeHeaders } from '../../../shared/Utils/taxHeaders.utils';
import { defaultGridLoading, manageGridLoading } from '../../../../util/shared/vue-global';
import { getTaxYearStatus } from '../../common-utils/tax-common.util';
import { taxConfigScope } from '../../../../util/shared/system-config-scopes';
import { toShortDate } from '../../../../util/shared/tmc-global';
import '../../../../assets/style.css';

export default {
  name: 'MergeAndFinalize',
  data() {
    return {
      baseCrudKey: 'mergeAndFinalize',
      headers: mergeNFinalizeHeaders,
      gridLoading: defaultGridLoading(),
      statusPolling: null,
      statusMessage: '',
    };
  },
  components: {
    CRUDList,
  },
  created() {
    this.loadConfig({ requiredScope: 'taxConfig' });
  },
  computed: {
    ...mapGetters('base/crud', [
      'items',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      mergeAndFinalizeItems: (state) => state.base.crud.items.mergeAndFinalize,
    }),
    getTotalAndExpetedTotalsItem() {
      const getItemArray = ['Totals', 'Expected Totals'];
      const getTotalAndExpetedTotals = (this.mergeAndFinalizeItems || [])
        .filter((ft) => getItemArray.includes(ft.whichRecords));
      return getTotalAndExpetedTotals || [];
    },
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setItem', 'setItems']),
    ...mapActions(['reAuth', 'flashError', 'flashWarn', 'flashSuccess']),
    ...mapActions('SystemConfig', [
      'loadConfig', 'upsertConfigSpecificFields',
    ]),
    ...mapActions('tax/newTaxroll', [
      'getAccessorFileMergeAndFinalize',
      'mergeAssessorTaxRollRecordsToTaxInquiryCollection',
      'pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress',
      'mergeAssessorSummaryToTaxrollSummary',
      'mergeAssessorCommentsToTaxComments',
      'loadAssesorTaxTotal',
    ]),
    ...mapActions('tax/taxInquires', [
      'callToUpdateTaxGlobalVariable',
    ]),
    async getAccessorFileMergeAndFinalizeMethod() {
      manageGridLoading(this, true, 'Searching...');
      await this.getAccessorFileMergeAndFinalize({
        baseCrudKey: this.baseCrudKey,
      });
      manageGridLoading(this, false);
    },
    async mergeTaxOwner() {
      const result = await this.mergeAssessorTaxRollRecordsToTaxInquiryCollection();
      if (result.statusCode === 204) {
        this.startTheCounter();
      } else {
        this.flashError('There was a problem while merging tax/owner.');
      }
    },
    startTheCounter() {
      this.statusPolling = setInterval(() => {
        this.callThePollingFunc();
      }, 2200);
    },
    callThePollingFunc() {
      const loadPromise = this.pollingToGetAssessorTaxRollRecordsToTaxInquiryCollectionProgress();
      loadPromise.then((res) => {
        if (res.statusCode === 200) {
          clearInterval(this.statusPolling);
          this.statusMessage = '';
          this.flashSuccess('Tax/Owner merged successfully.');
          this.getAccessorFileMergeAndFinalizeMethod();
        } else if (res.statusCode === 201) {
          clearInterval(this.statusPolling);
          this.flashError('There was a problem while merging tax/owner.');
          this.statusMessage = '';
        } else if (res.statusCode === 202) {
          this.statusMessage = `${res.totalRecords} records are being merged to tax inquiry collection.`;
        } else {
          clearInterval(this.statusPolling);
          this.flashError('There was a problem while merging tax/owner.');
          this.statusMessage = '';
        }
      });
    },
    async mergeSummary() {
      const result = await this.mergeAssessorSummaryToTaxrollSummary();
      if (result.statusCode === 200) {
        this.flashSuccess('Summary merged successfully.');
        this.getAccessorFileMergeAndFinalizeMethod();
      } else {
        this.flashError('There was a problem while merging summary.');
      }
    },
    async mergeComments() {
      const result = await this.mergeAssessorCommentsToTaxComments();
      if (result.statusCode === 200) {
        this.flashSuccess('Comments merged successfully.');
        this.getAccessorFileMergeAndFinalizeMethod();
      } else {
        this.flashError('There was a problem while merging comments.');
      }
    },
    async changeDefaultTaxYear() {
      const { currentTax } = getTaxYearStatus();
      const assessorTaxTotal = await this.loadAssesorTaxTotal({});
      const totalTaxAmount = assessorTaxTotal.totalTaxAmount || 0;

      if (currentTax) {
        const payload = {
          calledScope: taxConfigScope.scope,
          item: taxConfigScope.buildSpecificItem(this.taxSettingItem.id, {
            [taxConfigScope.specificFields.taxYear]: currentTax,
            [taxConfigScope.specificFields.newTaxRollDate]: toShortDate(),
            [taxConfigScope.specificFields.newTaxRollAmt]: totalTaxAmount,
          }),
        };
        await this.upsertConfigSpecificFields(payload);
        this.callToUpdateTaxGlobalVariable();
        this.flashSuccess('Default tax year changed successfully.');
      }
    },
    checkIfMergeTaxOwnerIsDisabled(fromWhere) {
      const getTotalAndExpetedTotalsItemList = this.getTotalAndExpetedTotalsItem;
      if (!getTotalAndExpetedTotalsItemList.length) return false;
      const getExpectedRecord = getTotalAndExpetedTotalsItemList.find((ft) => ft.whichRecords === 'Expected Totals');
      const getTotalRecord = getTotalAndExpetedTotalsItemList.find((ft) => ft.whichRecords === 'Totals');
      // if the expected record is less than the total record, then disable the button
      if ((getExpectedRecord[fromWhere] || 0) <= (getTotalRecord[fromWhere] || 0)) {
        return true;
      }
      return false;
    },
  },
};
</script>
